import React from "react";

function OrgChartBranch({ node }) {
  return (
    <li>
      <div className={`hr-org-node is-${node.kind}`}>
        <div className="hr-org-node-title">{node.title}</div>
        {node.subtitle ? (
          <div className="hr-org-node-sub">{node.subtitle}</div>
        ) : null}
      </div>
      {node.children?.length > 0 && (
        <ul>
          {node.children.map((child) => (
            <OrgChartBranch key={child.id} node={child} />
          ))}
        </ul>
      )}
    </li>
  );
}

function OrgChartTree({ tree }) {
  if (!tree) return null;
  return (
    <div className="hr-org-chart-wrap">
      <ul className="hr-org-chart">
        <OrgChartBranch node={tree} />
      </ul>
    </div>
  );
}

export default OrgChartTree;
